import { render, staticRenderFns } from "./AutoForm.vue?vue&type=template&id=6d12dbe0"
import script from "./AutoForm.vue?vue&type=script&lang=js"
export * from "./AutoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports